import React from "react";
import { Loader2, Search } from "lucide-react";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { LEAD_TYPES } from "./LeadCard";

const ProgressBox = ({ progress }) => (
  <div data-testid="lead-search-progress" className="mt-4 rounded-xl border border-[#E2DCD2] bg-[#FBF9F5] p-4">
    <div className="flex items-center justify-between text-sm font-medium text-[#1B3A4B]">
      <span className="flex items-center gap-2">
        <Loader2 className="w-4 h-4 animate-spin text-[#A6844A]" />
        {progress < 20 ? "Starting your web search…"
          : progress < 45 ? "Searching public listings & forums…"
          : progress < 70 ? "Checking bid boards & directories…"
          : progress < 90 ? "Verifying sources & contact details…"
          : "Finishing up…"}
      </span>
      <span className="tabular-nums text-[#5C564E]">{Math.round(progress)}%</span>
    </div>
    <div className="mt-2 h-2 w-full overflow-hidden rounded-full bg-[#ECE5D8]">
      <div className="h-full rounded-full bg-[#A6844A] transition-all duration-700 ease-out" style={{ width: `${progress}%` }} />
    </div>
    <p className="mt-2 text-xs text-[#5C564E]">Scanning the web for real prospects. This usually takes about a minute — you can keep working on your quote.</p>
  </div>
);

export const LeadSearchForm = ({ L, compact = false }) => (
  <div>
    <div className={`grid grid-cols-1 ${compact ? "" : "sm:grid-cols-2"} gap-4`}>
      <div className="space-y-1.5">
        <Label className="text-xs font-semibold uppercase tracking-widest text-[#5C564E]">Your service</Label>
        <Input data-testid="lead-service-input" placeholder="HVAC repair, painting, commercial cleaning…" value={L.service} onChange={(e) => L.setService(e.target.value)} />
      </div>
      <div className="space-y-1.5">
        <Label className="text-xs font-semibold uppercase tracking-widest text-[#5C564E]">City or ZIP</Label>
        <Input data-testid="lead-location-input" placeholder="Austin, TX or 78701" value={L.location} onChange={(e) => L.setLocation(e.target.value)} />
      </div>
    </div>
    <div className="mt-4">
      <Label className="text-xs font-semibold uppercase tracking-widest text-[#5C564E]">Who are you looking for?</Label>
      <div className="mt-2 inline-flex flex-wrap gap-1.5 rounded-full bg-[#F1ECE3] p-1" data-testid="lead-type-filter">
        {LEAD_TYPES.map((t) => (
          <button key={t.value} data-testid={`lead-type-${t.value}`} onClick={() => L.setLeadType(t.value)} className={`px-3.5 py-1.5 rounded-full text-sm transition-colors ${L.leadType === t.value ? "bg-[#1B3A4B] text-white shadow-sm" : "text-[#5C564E] hover:text-[#1B3A4B]"}`}>
            {t.label}
          </button>
        ))}
      </div>
    </div>
    <Button data-testid="lead-search-button" onClick={L.search} disabled={L.searching} className="mt-4 rounded-full bg-[#A6844A] hover:bg-[#8f6f3b] text-white h-11 px-6">
      {L.searching ? <><Loader2 className="w-4 h-4 mr-2 animate-spin" /> Searching…</> : <><Search className="w-4 h-4 mr-2" /> {L.trialAvailable ? "Run free trial search" : "Search (1 lead coin)"}</>}
    </Button>
    {L.searching ? <ProgressBox progress={L.progress} /> : (
      <p className="mt-2 text-xs text-[#5C564E]">No results? Your coin is automatically refunded — you only pay when real leads are delivered.</p>
    )}
  </div>
);
